module.exports = __webpack_public_path__ + "static/media/storage.f99db7b3.svg";